import React, { useEffect, useState } from 'react';
import { getFirestore, collection, onSnapshot, query, orderBy } from "firebase/firestore";

const XLinkz = ({ theme = 'dark' }) => {
  const [links, setLinks] = useState([]);
  const db = getFirestore();
  const isDark = theme === 'dark';

  useEffect(() => {
    const q = query(collection(db, "xLinkz"), orderBy("createdAt", "desc"));
    return onSnapshot(q, (snapshot) => {
      setLinks(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
  }, [db]);

  const isNew = (timestamp) => {
    if (!timestamp) return false;
    const now = new Date();
    const created = new Date(timestamp.seconds * 1000);
    const diffInHours = (now - created) / (1000 * 60 * 60);
    return diffInHours < 24;
  };

  const activeLinks = links.filter(link => link.status !== 'archived');

  const styles = {
    // Wrapper allows the list to grow with its parent column
    wrapper: {
      width: '100%',
      padding: '0px'
    },
    card: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 14px',
      marginBottom: '8px',
      borderRadius: '6px',
      textDecoration: 'none',
      transition: 'all 0.2s ease',
      background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
      border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.1)',
    },
    title: {
      fontSize: '0.95rem',
      fontWeight: '600',
      color: isDark ? '#ff8c00' : '#d97706',
      lineHeight: '1.2'
    },
    date: {
      fontSize: '0.7rem',
      color: isDark ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
    },
    viewBadge: {
      fontSize: '0.65rem',
      fontWeight: 'bold',
      padding: '3px 8px',
      borderRadius: '4px',
      backgroundColor: '#007bff',
      color: 'white',
      flexShrink: 0 // Prevents badge from squishing in narrow columns
    }
  };

  return (
    <div style={styles.wrapper}>
      {/* Header with File Count */}
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h4 className={`m-0 fw-bold ${isDark ? 'text-white' : 'orange'}`}>
          QUICK LINKZ
        </h4>
        <span className="badge rounded-pill bg-secondary" style={{ fontSize: '0.7rem' }}>
          {activeLinks.length} Files
        </span>
      </div>

      {/* Vertical List for Column Placement */}
      <div className="d-flex flex-column">
        {activeLinks.map(link => (
          <a 
            key={link.id} 
            href={link.fileUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={styles.card}
            className="xlinkz-item-hover"
          >
            <div className="d-flex align-items-center gap-2 overflow-hidden">
              <span style={{ fontSize: '1.2rem' }}>
                {link.linkType === 'url' ? '🔗' : '📄'}
              </span>
              
              <div className="d-flex flex-column text-start overflow-hidden">
                <div className="d-flex align-items-center gap-1">
                  <span className="text-truncate" style={styles.title}>{link.title}</span>
                  {isNew(link.createdAt) && (
                    <span className="badge bg-danger" style={{ fontSize: '0.55rem', padding: '2px 4px' }}>NEW</span>
                  )}
                </div>
                {link.updatedAt && (
                  <span style={styles.date}>
                    Updated: {new Date(link.updatedAt.seconds * 1000).toLocaleDateString()}
                  </span>
                )}
              </div>
            </div>

            <div style={styles.viewBadge}>VIEW</div>
          </a>
        ))}

        {activeLinks.length === 0 && (
          <div className={`text-center py-4 small ${isDark ? 'text-white-50' : 'text-muted'}`}>
            No links found.
          </div>
        )}
      </div>

      <style>{`
        .xlinkz-item-hover:hover {
          background: ${isDark ? 'rgba(255, 255, 255, 0.1) !important' : 'rgba(0, 0, 0, 0.06) !important'};
          transform: translateX(3px); /* Subtle side slide for list items */
        }
      `}</style>
    </div>
  );
};

export default XLinkz;